import classNames from 'classnames/bind';
import config from 'config/index';
import { IOta, OtaType } from 'detail/types';
import styles from './index.module.scss';
import { getCsType } from './util';

const cx = classNames.bind(styles);

interface IProps {
  otaInfo: IOta;
  clickCodePrefix: string;
}

export default function Information({ otaInfo, clickCodePrefix }: IProps) {
  const {
    active,
    expName: otaName,
    isCsCenter,
    isCsCenterEmail,
    isKoreanWebsite,
    otaType,
  } = otaInfo;
  const isGlobal =
    otaType === OtaType.GLOBAL_AIRLINE || otaType === OtaType.GLOBAL_OTA;
  const mypage = active?.mypage;
  const csType = getCsType(isCsCenter, isCsCenterEmail);

  return (
    <div className={cx('information')}>
      <dl className={cx('list')}>
        {mypage ? (
          <>
            <dt className={cx('name')}>네이버 여행MY에서 예약 확인 가능</dt>
            <dd className={cx('value')}>
              네이버와 여행사 페이지 모두에서 예약정보 제공을 동의하시면 네이버
              여행MY에서 예약정보를 확인할 수 있습니다.
            </dd>
            <dt className={cx('name')}>N트래블클럽 이용실적 반영</dt>
            <dd className={cx('value')}>
              예매하신 항공권을 이용 완료하시면, 네이버 여행멤버십 N트래블클럽
              등급 업그레이드를 위한 구매 이력이 쌓입니다.
            </dd>
            <dd className={cx('link')}>
              <a
                href={`${config.eventpromotion}/promotion/travelclub`}
                target="_blank"
                rel="noreferrer"
                data-event-nlog="click"
                data-event-area-code={`${clickCodePrefix}.infotravelclub`}
              >
                자세히 보러가기
              </a>
            </dd>
            <dt className={cx('name')}>
              항공권 발권 시 네이버 호텔 할인 쿠폰 제공
            </dt>
            <dd className={cx('value')}>
              항공권 발권이 완료되면 여행사로부터 발권 완료 문자/메일을 받게
              되며, 네이버 시크릿몰 호텔 예약 시 사용할 수 있는 최대 15% 할인
              쿠폰이 발급됩니다.
            </dd>
            <dd className={cx('link')}>
              <a
                href={`${config.eventpromotion}/promotion/secretcoupon`}
                target="_blank"
                rel="noreferrer"
                data-event-nlog="click"
                data-event-area-code={`${clickCodePrefix}.infocoupon`}
              >
                자세히 보러가기
              </a>
            </dd>
          </>
        ) : (
          <>
            <dt className={cx('name')}>네이버 여행MY에서 예약 확인 불가</dt>
            <dd className={cx('value')}>
              네이버에 예약정보를 제공하지 않는 여행사로, 네이버 여행MY에서
              예약정보를 확인할 수 없습니다.
            </dd>
            <dt className={cx('name')}>N트래블클럽 이용실적 반영 불가</dt>
            <dd className={cx('value')}>
              예약정보 미제공 여행사로, N트래블클럽 혜택이 적용되지 않습니다.
            </dd>
          </>
        )}
        {isGlobal &&
          (csType ? (
            <>
              <dt className={cx('name')}>한국어 CS 가능 ({csType})</dt>
              <dd className={cx('value')}>
                {otaName}은/는 해외업체로 {csType} 한국어 고객센터를 운영합니다.
              </dd>
            </>
          ) : (
            <>
              <dt className={cx('name')}>한국어 CS 불가능</dt>
              <dd className={cx('value')}>
                {otaName}은/는 해외업체로 한국어 고객센터를 운영하지 않습니다.
              </dd>
            </>
          ))}
        {isGlobal &&
          (isKoreanWebsite ? (
            <>
              <dt className={cx('name')}>한국어 사이트 운영</dt>
              <dd className={cx('value')}>
                {otaName}은/는 해외업체로 한국어 사이트가 제공됩니다.
              </dd>
            </>
          ) : (
            <>
              <dt className={cx('name')}>한국어 사이트 미운영</dt>
              <dd className={cx('value')}>
                {otaName}은/는 해외업체로 한국어 사이트가 미제공됩니다.
              </dd>
            </>
          ))}
      </dl>
    </div>
  );
}
